import { ROUTES, EXPONDO_MIDDLEWARE_ROUTES } from '~/constants/routes';
import { getSlugForRoute, getNameForRoute } from '~/helpers/routes/getPageInformation';
import { runExpondoMiddlewareRequest } from '~/helpers/middleware/runExpondoMiddlewareRequest';
import { AllowedMethods } from '~/types/expondoMiddleware';

const canEnterPayment = cart => cart.shippingInfo && cart.shippingAddress;
export default async ({ app, $axios, $config, req }) => {
  const { data: getMeResponse } = await runExpondoMiddlewareRequest({
    $axios,
    $config,
    endpoint: EXPONDO_MIDDLEWARE_ROUTES.CT.ROOT + EXPONDO_MIDDLEWARE_ROUTES.CT.GET_ME,
    method: AllowedMethods.post,
    headers: req?.headers,
  });
  if (!getMeResponse?.data || !getMeResponse?.data?.me?.activeCart) {
    app.context.redirect({ name: getNameForRoute(ROUTES.HOME), replace: true });
  }
  const { activeCart } = getMeResponse?.data?.me;
  if (!canEnterPayment(activeCart)) {
    app.context.redirect(getSlugForRoute(ROUTES.CHECKOUT_ADDRESSES));
  }
};
